module.exports = __webpack_public_path__ + "img/IMG_6258_L_Wood.06748dc3.jpg";